import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';
import getSettingItems from '@/structure/settings';
import useDashboardLinkPrefix from '@/hooks/useDashboardLinkPrefix';
import { getDashboardLinkPrefix } from '@/utils/routes';

const ProfileNavMenu = ({ children, activeProperty }) => {
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const sections = getSettingItems({
    dashboardLinkPrefix,
    propertyDashboardLinkPrefix: getDashboardLinkPrefix(
      activeProperty?.boligmappaNumber
    ),
    isMobile: true,
  });
  if (sections) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent className="w-56 pb-3 font-circular">
          {sections.map((section, index) => (
            <DropdownMenuGroup className={`${index !== 0 && 'pt-4'}`}>
              {section.title && (
                <>
                  <DropdownMenuLabel className="text-[10px] uppercase text-muted-foreground">
                    {section.title}
                  </DropdownMenuLabel>
                  <DropdownMenuSeparator />
                </>
              )}
              {section.items.map(
                ({ to, text, isExternalLink, icon: Icon, noBorder }) => (
                  <>
                    <DropdownMenuItem className="text-base font-medium" asChild>
                      {isExternalLink ? (
                        <a href={to} target="_blank" rel="noopener noreferrer">
                          <Icon />
                          {text}
                        </a>
                      ) : (
                        <Link to={to}>
                          <Icon />
                          {text}
                        </Link>
                      )}
                    </DropdownMenuItem>
                    {!noBorder && <DropdownMenuSeparator />}
                  </>
                )
              )}
            </DropdownMenuGroup>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  return null;
};

export default ProfileNavMenu;
